import styled from "styled-components"

export const Container = styled.div`
    background-color: var(--medGrey);
    display: flex;
`

export const Wrapper = styled.div`
    flex: 1;
`

export const Main = styled.div`
    margin-top: 10px;
    flex: 4;
    color: var(--darkGrey);
    padding: 20px;
`

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Title = styled.h1`
`

export const GridWrapper = styled.div`
    display: flex;
    margin-top: 20px;
    background-color: var(--darkGrey);
`

export const Action = styled.div`
    display: flex;
    align-items: center;
`

export const StyledIcon = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`
